import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom'
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import useAppLayout from './hooks/useAppLayout';
import API_URL from './api/config';
import { useQuery } from '@tanstack/react-query';
import ReactModal from 'react-modal';
import ImageWithLoader2 from './components/ImageWithLoader2';
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import InfiniteScroll from "react-infinite-scroll-component";


function SearchPeople() {
  const { menu, toggleMobileMenu } = useAppLayout();

  const navigate = useNavigate();
  
  const [selectedMember, setSelectedMember] = useState(null);

  const [searchModalOpen, setSearchModalOpen] = useState(false);


  const [searchImageModalOpen, setSearchImageModalOpen] = useState(false);

  const limit = 10;

  const [members, setMembers] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [search, setSearch] = useState("");

  const [isFetching, setIsFetching] = useState(false);


  const fetchMembers = async () => {

    if (isFetching) return;
    setIsFetching(true);

    try {
      const res = await axios.get(`${API_URL}/search-family-members-api`, {
        params: { page, limit, q: search },
        withCredentials: true,
      });
      const newData = res.data || [];

      setMembers(prev => [...prev, ...newData]);
      if (newData.length < limit) setHasMore(false);
    } catch (e) {
      console.error("fetch error:", e.response?.data || e.message);
      setHasMore(false);
    }finally {
      setIsFetching(false);
    }
  };

  // reset when search changes
  useEffect(() => {
    setMembers([]);
    setHasMore(true);
    setPage(1);
  }, [search]);

  // fetch on page/search changes
  useEffect(() => {
    fetchMembers();
    // eslint-disable-next-line
  }, [page, search]);

  const fetchNext = () => setPage(p => p + 1);

  const selectedIsPrivate =
  selectedMember?.is_private === true || selectedMember?.privacy === 'private';

  return (
    <div className={`main-wrapper ${menu ? 'slide-nav': ''}`}>
            <Header onMenuClick={(value) => toggleMobileMenu()} />
            <Sidebar />

        <div className='page-wrapper'>
          <div className='content container-fluid'>

      
          <div className='row'>
              <div className="col-md-6">
              <div className="text-center mb-2">
                      <h5 className="fw-bold text-dark mb-1">
                        <i className="bi bi-heart-fill text-success me-2"></i>
                        Search People
                      </h5>
                      <p className="text-muted small mb-0" style={{fontSize: '12.5px'}}>
                        Find and connect with people in your family network.
                      </p>
                    </div>
                </div>
            
                <div className="col-md-6">
                <div
                        className="input-group rounded-pill overflow-hidden shadow-sm"
                        style={{  background: '#fff' }}
                      >
                        <span className="input-group-text bg-white border-0">
                          <i className="bi bi-search text-muted" />
                        </span>

                        <input
                          type="text"
                          className="form-control border-0 py-2 small"
                          placeholder="Search name"
                          value={search}
                            onChange={(e) => setSearch(e.target.value)}
                          style={{ boxShadow: 'none', fontSize: '0.9rem' }}
                          aria-label="Search people"
                        />

                        
                      </div> 
                </div>

          </div>
          
          
                       
          <div id="scrollArea"
                          style={{
                              height: "calc(100vh - 120px)",
                              overflow: "auto",
                              marginBottom: "20px",
                            }} >

  {members.length === 0 && isFetching ? (
    <div className="loadingspinnerDiv">
      <div className="loadingspinner"></div>
    </div>
  ) : (
    <InfiniteScroll
  dataLength={members.length}
  next={fetchNext}
  hasMore={hasMore}
  loader={<h4 className="text-center py-4">Loading...</h4>}
  endMessage={
    <p className="text-center py-4 text-gray-500">
      <b>No more results</b>
    </p>
  }
  scrollableTarget="scrollArea"
>
  {/* Row for 3 cards per row with spacing */}
  <div className="row gy-4 gx-3 mx-1 mt-1"> {/* gy=vertical gap, gx=horizontal gap */}
    {members.map((member) => (
      <div
        key={member.id}
        className="col-12 col-sm-6 col-md-4"
      >


<div className="col">
      <div className="card border-0 shadow-sm rounded-4 overflow-hidden h-100">
        {/* Media / placeholder (header area) style={{ height: 220, overflow: 'hidden' }}*/}
        <div className="position-relative d-flex align-items-center justify-content-center"  >

              <ImageWithLoader2
                    src={`${API_URL}/images/${member.image_name}`}
                    placeholder="https://oret.africa/tree/img/placeholder-human-icon.jpg"
                    fadeDuration={800}
                    blurAmount={15}
                    alt={member.name}
                   className="w-100 h-100 object-fit-contain"
                     /*className="w-100 h-100 object-fit-cover"*/
                  />
           
        </div>
{/* Content (compact) */}
<div
  className="card-body text-center p-0 d-flex flex-column align-items-center"
  style={{ gap: '1px', padding: '0.75rem 0.5rem' }}
>
  <h6
    className="fw-semibold mb-0 text-truncate"
    style={{ fontSize: '1.3rem', lineHeight: '2.25rem', overflowX: 'hidden' }}
    
  >
    {member.n_prefix} {member.name} {member.last_name} {member.surname}
  </h6>

   
    <button
      type="button"
      className="btn text-white fw-semibold rounded-pill btn-sm"
      style={{
        backgroundImage: 'linear-gradient(135deg, #75B437, #184A2C)',
        border: 'none',
        padding: '0.35rem 2.0rem',
        fontSize: '0.85rem',
        marginBottom: '10px'
      }}
      onClick={() => {
        setSelectedMember(member);      
        setSearchImageModalOpen(true); 
      }}
      title="View details"
    >
      View Details
    </button>
   
</div>



      </div>
    </div>


    
        
      </div>
    ))}
  </div>
</InfiniteScroll>
  )}
</div>
                  
          
          
                 
          
          
          

{selectedMember && (
<ReactModal
  isOpen={searchImageModalOpen}
  onRequestClose={() => setSearchImageModalOpen(false)}
  className="Modal"
  overlayClassName="Overlay"
  style={{
    overlay: {
     
      zIndex: 1050,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    content: {
      inset: 'auto',
      margin: 0,
      width: 'min(90vw, 460px)',
      maxHeight: '88vh',
      borderRadius: '16px',
      padding: 0,
      overflow: 'hidden',
      border: 'none',
      
      display: 'flex',
      flexDirection: 'column',
      background: '#fff',
    },
  }}
>
  
  {selectedMember && (
    <div className="w-100 h-100 d-flex flex-column">
      {/* Bigger banner */}
      <div
        className="position-relative"
        style={{
          minHeight: 160,
        }} >
       
      
       
<div
style={{
  position: "relative",
  height: "260px",
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  overflow: "hidden",
  cursor: "grab", // Desktop hint
}}
>

  
{/* Overlay hint */}

<div
  style={{
    position: "absolute",
    top: "8px",
    left: "50%",
    width: "72%", 
    transform: "translateX(-50%)",
    background: "rgba(0,0,0,0.6)",
    color: "#fff",
    padding: "3px 8px",
    borderRadius: "4px",
    fontSize: "9px",
    zIndex: 2,
    animation: "fadeOut 2s 3s forwards", // Fades after 3s
  }}
>
  <center>
  Pinch to Zoom · Drag to Move
  </center>
  
</div>


{/* Optional zoom icon in corner */}
<div
  style={{
    position: "absolute",
    bottom: "8px",
    right: "8px",
    zIndex: 2,
  }}
>
  <i className="fas fa-search-plus" style={{ color: "#184A2C", fontSize: "12px" }}></i>
</div>


<button
  type="button"
  className="btn-close modalCloseButton"
  onClick={() => setSearchImageModalOpen(false)}
  style={{
    position: "absolute",
    top: "8px",
    right: "8px",
    zIndex: 3,
    borderRadius: "50%",
    padding: "4px",
  }}
></button>

<TransformWrapper
  doubleClick={{ mode: "zoomIn" }}
  pinch={{ disabled: false }}
  wheel={{ step: 0.1 }}
>
  <TransformComponent>
    <ImageWithLoader2
      src={`${API_URL}/images/${selectedMember.image_name}`}
      placeholder="https://oret.africa/tree/img/placeholder-human-icon.jpg"
      fadeDuration={800}
      blurAmount={15}
      alt={selectedMember.name}
      className=" top-0 start-0 w-100 h-100 object-fit-cover"
         style={{ opacity: 100, filter: 'grayscale(0%)' }} />
  </TransformComponent>
</TransformWrapper>

{/* Fade out animation */}
<style>
  {`
    @keyframes fadeOut {
      to {
        opacity: 0;
        visibility: hidden;
      }
    }
  `}
</style>
</div>
          

          

        
      </div>

      {/* Name */}
      <div className="px-2 pt-2">
        <div className="fw-semibold text-truncate" style={{ fontSize: '1.05rem' }}>
          {selectedMember.n_prefix}{' '}{selectedMember.name}{' '}
          {selectedMember.last_name}
        </div>
      </div>

      {/* Divider */}
      <div style={{ height: 6, background: '#fff' }} />

      {/* Body */}
      <div className="px-2 pb-2" style={{ overflowY: 'auto' }}>
        {selectedIsPrivate ? (
          <div className="text-center text-muted py-3 small">
            <i className="bi bi-lock me-1" />
            This member’s details are private.
          </div>
        ) : (
          <>
            {/* Top Stat Tiles — Family, Tribe (Age removed from tiles) */}
            <div
              className="d-grid mb-2"
              style={{ gridTemplateColumns: '1fr 1fr', gap: 8 }}
            >
              {[
                { label: 'Family', value: selectedMember.familyName },
                { label: 'Tribe', value: selectedMember.tribeName },
              ].map((it, i) => (
                <div
                  key={i}
                  className="text-center"
                  style={{
                    background: '#F3FBF5',
                    border: '1px solid #E4F2E9',
                    borderRadius: 12,
                    padding: '10px 6px',
                  }}
                >
                  <div className="text-muted" style={{ fontSize: '0.75rem' }}>{it.label}</div>
                  <div className="fw-bold" style={{ color: '#184A2C', fontSize: '0.9rem' }}>
                    {it.value || '—'}
                  </div>
                </div>
              ))}
            </div>

            {/* Bottom List — Age moved here, plus Sub-Tribe, Clan, Sub-Group, Totem */}
            <div
              className="rounded-4"
              style={{ background: '#FBFDFC', border: '1px solid #EEF6F0' }}
            >
              {[
                { label: 'Age', value: selectedMember.age },
                { label: 'Sub-Tribe', value: selectedMember.subtribeName },
                { label: 'Clan', value: selectedMember.clanName },
                { label: 'Sub-Group', value: selectedMember.subgroupName },
                { label: 'Totem', value: selectedMember.totemName },
              ].map((row, idx, arr) => (
                <div
                  key={idx}
                  className="d-flex align-items-center justify-content-between px-3"
                  style={{
                    padding: '8px 10px',
                    borderBottom: idx < arr.length - 1 ? '1px solid #EEF6F0' : 'transparent',
                  }}
                >
                  <span className="text-muted" style={{ fontSize: '0.75rem' }}>{row.label}</span>
                  <span
                    className="d-inline-flex align-items-center gap-2 fw-semibold"
                    style={{ color: '#0C5A2D', fontSize: '0.85rem' }}
                  >
                    <span>{row.value || '—'}</span>
                    {row.value && (
                      <span
                        aria-hidden
                        style={{
                          display: 'inline-block',
                          width: 14,
                          height: 2,
                          background: '#0C5A2D',
                          borderRadius: 2,
                        }}
                      />
                    )}
                  </span>
                </div>
              ))}
            </div>

            {/* CTA */}
            <div className="pt-2">

            <button 
            className="btn w-100 text-white fw-semibold rounded-pill py-1"
            style={{
              backgroundImage: 'linear-gradient(135deg, #75B437, #184A2C)',
              border: 'none',
              boxShadow: '0 8px 18px rgba(24,74,44,0.25)',
              fontSize: '0.9rem',
            }}
            onClick={() => navigate('/chat', { state: { receiverId: selectedMember.id } })}>
              <i className="bi bi-chat-dots me-2" />
              Start Conversation
            </button>

             
            </div>
          </>
        )}
      </div>
    </div>
  )}
</ReactModal>
)}

          
        
          
            

          </div>
        </div>
      </div>
    
  );
}

export default SearchPeople;
